import type { StateCreator } from 'zustand';

export type ViewSize = 'small' | 'medium' | 'large';

export interface ViewSlice {
  viewCrop: boolean;
  setViewCrop: (crop: boolean) => void;
  viewSize: ViewSize;
  setViewSize: (size: ViewSize) => void;
}

export const viewInitialState = {
  viewCrop: true,
  viewSize: 'medium' as ViewSize,
};

export const createViewSlice: StateCreator<ViewSlice, [], [], ViewSlice> = (
  set
) => ({
  ...viewInitialState,

  setViewCrop: (viewCrop) => set({ viewCrop }),
  setViewSize: (viewSize) => set({ viewSize }),
});
